(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
